import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroupTypeHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42 0H0V42H42V0Z",
			fill: "#FFE6CB"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_29947_38304)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M34.1046 30.1427V16.7292C34.1046 16.1781 33.9609 15.6465 33.6987 15.1814C33.6663 15.123 33.6314 15.0662 33.5949 15.0102C33.3408 14.6181 32.9983 14.2821 32.586 14.0321L22.9077 8.15976C22.812 8.10132 22.7129 8.051 22.6123 8.00311C22.5555 7.97632 22.4987 7.95116 22.441 7.92844C22.3331 7.88542 22.2243 7.84646 22.1139 7.81643C22.045 7.79776 21.976 7.78071 21.9062 7.7661C21.773 7.73851 21.6383 7.72065 21.5036 7.71091C21.4946 7.71091 21.4857 7.70929 21.4768 7.70848C21.4086 7.70442 21.3396 7.70117 21.2714 7.70117C20.9435 7.70117 20.6156 7.75393 20.3007 7.8562C20.2601 7.86919 20.2203 7.88298 20.1806 7.89759C20.0637 7.94061 19.9493 7.99012 19.8372 8.04694C19.834 8.04856 19.8299 8.05018 19.8267 8.05181C19.8129 8.05911 19.7991 8.06723 19.7853 8.07453C19.735 8.10132 19.6847 8.12892 19.6351 8.15895L9.9553 14.0329C9.01297 14.6043 8.4375 15.627 8.4375 16.7292V30.1419C8.4375 31.1768 8.93505 32.0948 9.7045 32.6702C9.98777 32.8821 10.3084 33.0476 10.6541 33.1548C10.9504 33.2473 11.2653 33.2968 11.5924 33.2968H30.9505C31.4951 33.2968 32.0072 33.1588 32.4545 32.9162C32.9463 32.6491 33.3587 32.2546 33.6484 31.7782C33.7012 31.6914 33.7499 31.6021 33.7937 31.5104C33.8992 31.2912 33.9796 31.0575 34.0323 30.814C34.0372 30.7929 34.0413 30.7717 34.0453 30.7506C34.0835 30.5542 34.1046 30.3505 34.1046 30.1427Z",
					fill: "#F47920"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.4961 29.5241H19.2239V25.6281C19.2239 24.4975 20.1403 23.5811 21.2709 23.5811C22.4016 23.5811 23.3179 24.4975 23.3179 25.6281V29.5241H30.0458V17.5237L21.2709 12.1992L12.4961 17.5237V29.5241Z",
					fill: "#7C3A00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.5303 11.7715L30.3047 17.0967L30.5459 17.2422V30.0244H22.8184V25.6279C22.8183 24.7735 22.1249 24.0811 21.2705 24.0811C20.4163 24.0813 19.7237 24.7737 19.7236 25.6279V30.0244H11.9961V17.2422L21.2705 11.6143L21.5303 11.7715ZM23.8184 29.0244H29.5459V17.8047L21.2705 12.7842L12.9961 17.8047V29.0244H18.7236V25.6279C18.7237 24.2214 19.864 23.0813 21.2705 23.0811C22.6772 23.0811 23.8183 24.2212 23.8184 25.6279V29.0244Z",
					fill: "#BFBFBF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_29947_38304",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 25.6671,
				height: 25.5948,
				fill: "white",
				transform: "translate(8.4375 7.70215)"
			})
		}) })
	]
});
export default SvgGroupTypeHome;
